"use client";

import React from "react";
import { useTranslations, useLocale } from "next-intl";
import { ColletteCarousel, ColletteIconButton } from "@collette-travel/collette-common-controls";
import { Box, Stack, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import TravelStyleCard from "@/components/product-detail-page/modals/travel-styles/travel-style-card";
import { TravelStyleDetail } from "@/types/dto/pdp/pdp-header-about";
import sortTravelStyles from "@/utils/pdp-utils";

interface TravelStyleModalProps {
  thisTourTravelStyle: TravelStyleDetail["name"][];
  travelStyles: TravelStyleDetail[];
  handleClose: () => void;
}

const TravelStyleModal = ({
  thisTourTravelStyle,
  travelStyles,
  handleClose
}: TravelStyleModalProps) => {
  const locale = useLocale();
  const t = useTranslations("PDP");

  const sortedStyles = sortTravelStyles(thisTourTravelStyle, travelStyles, locale);

  return (
    <Stack
      sx={{
        borderRadius: "1rem",
        backgroundColor: "background.default",
        overflow: "hidden"
      }}
    >
      <ColletteIconButton
        testId="travel-style-modal-close-button"
        onClick={handleClose}
        sx={{
          mt: "-0.8rem",
          mr: "-0.8rem",
          position: "absolute",
          top: 24,
          right: 24
        }}
      >
        <Close />
      </ColletteIconButton>
      <Stack gap="2rem">
        <Box sx={{ padding: { xs: "4rem 4rem 0", md: "2rem" } }}>
          <Typography component="p" variant="h5" data-testid="travel-style-modal-header">
            {t("Travel Styles")}
          </Typography>
        </Box>
        <Box
          sx={{
            padding: "0 6.5rem 4rem"
          }}
        >
          <ColletteCarousel
            testId="travel-styles"
            variant="multi-card"
            arrowPosition="sides"
            carouselContainerSx={{
              overflow: "visible"
            }}
          >
            {sortedStyles.map((style) => (
              <TravelStyleCard
                key={style.name}
                name={style.name}
                description={style.description}
                href={style.ctaUrl}
                id={style.name}
                ctaText={style.ctaText}
                image={style.imageUrl}
                imageAlt={style.imageAltText}
                highlight={thisTourTravelStyle.includes(style.name)}
              />
            ))}
          </ColletteCarousel>
        </Box>
      </Stack>
    </Stack>
  );
};

export default TravelStyleModal;
